import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Organization } from '../../types/organization';
import { OrganizationService } from '../../services/organization.service';
import { LogService } from '../../services/log.service';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs/index';
import { ForgotUsernameService } from '../../services/forgot-username.service';
import { BaseForm } from '../../interfaces/BaseForm';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html'
})
export class ForgotUsernameComponent extends BaseForm implements OnInit {
  email: string;
  organization: Organization;

  @ViewChild('emailInput')
  emailInput;

  constructor(
    private router: Router,
    private log: LogService,
    private orgService: OrganizationService,
    private usernameService: ForgotUsernameService
  ) {
    super(log);
  }

  ngOnInit() {
    this.clear();
    this.log.trace('forgot-username form loaded');
  }

  isValid(): boolean {
    if (this.isSubmitInProgress || !this.email) {
      return false;
    }
    return true;
  }

  clear() {
    this.email = '';
    this.organization = null;
    this.emailInput.nativeElement.focus();
  }

  submit() {
    this.isSubmitInProgress = true;
    this.usernameService.forgotUsername(this.email, this.onErrorCallback);
  }
}
